<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card class="m-20">
              <v-card-title class="pb-5">
                <v-btn @click="$router.push('/adminTickets')" class="btn-back">
                  <span class="flaticon2-reply icon-lg"></span>
                  بازگشت
                </v-btn>
                <v-spacer/>
                تغییر وضعیت تیکت
                <v-spacer/>
                <v-btn @click="editTicket"
                       class="btn-update">
                  <v-icon>mdi-update</v-icon>
                  بروز رسانی
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md6 lg12 xl12 class="p-2">
                    <v-text-field
                        v-model="title"
                        label="عنوان تیکت"
                        required
                        outlined

                    ></v-text-field>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">


                    <!--                    <v-select-->
                    <!--                        v-model="roleid"-->
                    <!--                        :rules="rules.status"-->
                    <!--                        :items="roles"-->
                    <!--                        item-text="name_fa"-->
                    <!--                        item-value="id"-->
                    <!--                        :error-messages="errors.role_id"-->
                    <!--                        label="انتخاب نقش"-->
                    <!--                        outlined-->
                    <!--                        dense-->
                    <!--                        return-object></v-select>-->


                    <v-select
                        v-model="selectedDepartment"
                        :items="departments"
                        item-text="title"
                        v-on:change="notifyStatus"
                        item-value="id"
                        outlined
                        label="دپارتمان"
                    >
                    </v-select>
                  </v-flex>


                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">

                    <!--  <p>اولویت بندی</p>-->

                    <v-btn-toggle
                        class="mr-8"
                        v-model="importance"
                        shaped
                        color="#3294AA"
                        mandatory
                    >
                      <v-btn value="3">
                        معمولی
                      </v-btn>

                      <v-btn value="2">
                        مهم
                      </v-btn>

                      <v-btn value="1">
                        بسیار مهم
                      </v-btn>


                    </v-btn-toggle>

                  </v-flex>
                </v-row>


                <v-row>

                  <v-radio-group row v-model="status">
                    <v-radio label="باز" color="primary" value="open"></v-radio>
                    <v-radio label="بسته" color="primary" value="close"></v-radio>
                  </v-radio-group>

                </v-row>

              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";
import PermissionPicker from "@/view/pages/pickers/permissionPicker";
import userPicker from "@/view/pages/pickers/userPicker";


export default {
  props: ['id'],
  components: {PermissionPicker, userPicker},
  data() {
    return {
      loading: false,
      title: '',
      notify: false,
      text: '',
      status: '',
      ckEditor: false,
      importance: '',
      departments: [],
      selectedDepartment: null,
      textArea: true,
      notify_type: 'sms',
      status_types: [
        {name: 'info', value: 'اطلاع رسانی'},
        {name: 'success', value: 'موفقیت'},
        {name: 'warning', value: 'هشدار'},
        {name: 'danger', value: 'خطر'}
      ],
      notify_types: [
        {name: 'sms', value: 'پیامک'},
        {name: 'email', value: 'ایمیل'},
        {name: 'notification', value: 'اطلاع رسانی'},
        {name: 'push_notification', value: 'اطلاع رسانی پنل'}
      ],
      cost: '',
      users: [],
      extras: {
        notify_at: '',
        status_type: '',
        icon: ''
      },
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        }
      },
    }
  },
  created() {
    this.getDepartments()
    this.getTicket()
  },
  methods: {

    getTicket() {
      this.requestApiGet(`ticket/${this.id}`)
          .then(({data}) => {
            this.title=data.title
            this.selectedDepartment=data.department_id
            this.importance=data.importance
            this.status=data.status
          })
    },
    editTicket() {
      this.loading = true;
      this.requestApiPut(`ticket/${this.id}`, {
        title: this.title,
        description: this.text,
        department_id: this.selectedDepartment,
        status: this.status,
        importance: this.importance,
      }).then((response) => {
        this.loading = false;
        this.$toast.success('تیکت با موفقیت ویرایش شد.');
        this.$router.push({name: 'adminTickets.index'});
      }).catch(({response}) => {
        this.errors = response.data;
        ;
        this.loading = false;
      });
    },

    getDepartments() {
      this.requestApiGet('department',
      ).then(response => {
        this.departments = response.data.data;
      })
    },


    notifyStatus(data) {
      if (data.name === 'sms') {

        this.ckEditor = false;
        this.textArea = true;
        this.notify = false
      } else {
        this.notify = true
        this.textArea = false;
        this.ckEditor = true;
        this.cost = '';
      }

    }
  }
}
</script>